import dbuyGenericFields from './dbuyGenericFields';
const dbuyModal2ValidationSchema = {
    required: ["syfPartnerId", "transAmount1"],
    properties: dbuyGenericFields
};

export default dbuyModal2ValidationSchema;